import ShippingModal from './ShippingModal';

export default ShippingModal;


// WEBPACK FOOTER //
// ./src/components/ShippingModal/index.jsx